import { ApiError, ValidationError } from '../api/client'
import { consentState } from '../clients/consent'
import type { Consent } from '../types/app'

// The API refuses a seventh photo on an appointment (409 photo-limit); the
// picker uses the same number so she is told before she tries.
export const MAX_NOTE_PHOTOS = 6

// photosLeft is how many more photos fit beside those already saved and those
// picked but not yet uploaded.
export function photosLeft(saved: number, queued: number): number {
  return Math.max(0, MAX_NOTE_PHOTOS - saved - queued)
}

// photoConsentStands: the client's newest photos consent is a grant. Records
// consent does not cover photos; the API checks this too (409 photo-consent-needed).
export function photoConsentStands(history: Consent[]): boolean {
  return consentState(history, 'photos') === 'granted'
}

// photoErrorMessage is what a failed upload says. firstName is only for the
// missing-consent message; anything unexpected, a dropped connection included,
// is just "Didn't upload" and she can try again.
export function photoErrorMessage(e: unknown, firstName?: string): string {
  if (e instanceof ValidationError && 'photo' in e.fields) return 'Choose a JPEG or WebP photo under 2 MB.'
  if (e instanceof ApiError) {
    switch (e.problem) {
      case 'photo-consent-needed':
        return `Record that ${firstName || 'this client'} agreed to treatment photos first.`
      case 'photo-limit':
        return `An appointment can have up to ${MAX_NOTE_PHOTOS} photos.`
      case 'photos-unavailable':
        return "Photos can't be added right now."
    }
  }
  return "Didn't upload"
}
